<template>
    <div class="basicFuncTable">
        <!-- <Table style="width: 100%;margin-top: 30px;"  max-height='500'   :columns="titleNameFun" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table> -->
        <!-- <Table style="width: 100%;margin-top: 30px;" :max-height='maxHeight' :class="dataParams.communicateProtocol==3?'hyecoTable':''"   :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='dataObj.loading'></Table> -->
        <Table style="width: 100%;margin-top: 30px;" :max-height="readOnly?400:'-'" :class="[!readOnly && dataParams.communicateProtocol==3?'hyecoTable':'',!readOnly && page.paging?'hyecoTablePage':'']"   :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='dataObj.loading'></Table>
        <Page v-if="page.paging" @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[50,100]" placement="top" class="pages"/>
       
        <NumberType      v-if="readOnly" :showSetModel.sync="IndentyNameBox.showSetModelType" :published="dataObj.published"   :isGener="true" :pageId="formData.pageId"   :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></NumberType>
        <TimeType        v-if="readOnly" :showSetModel.sync="IndentyNameBox.showSetModelType" :published="dataObj.published"     :isGener="true" :pageId="formData.pageId"   :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></TimeType>
        <EnumerationType v-if="readOnly" :showSetModel.sync="IndentyNameBox.showSetModelType" :published="dataObj.published"   :isGener="true" :pageId="formData.pageId"   :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></EnumerationType>
        <EnumerationBool v-if="readOnly" :showSetModel.sync="IndentyNameBox.showSetModelType" :published="dataObj.published"  :isGener="true" :pageId="formData.pageId"   :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></EnumerationBool>
        <BitvalueType    v-if="readOnly" :showSetModel.sync="IndentyNameBox.showSetModelType" :published="dataObj.published" :isGener="true" :pageId="formData.pageId"   :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></BitvalueType>
        <StructType      v-if="readOnly" :showSetModel.sync="IndentyNameBox.showSetModelType" :published="dataObj.published"   :isGener="true" :pageId="formData.pageId"   :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></StructType>
        <ArrayType       v-if="readOnly" :showSetModel.sync="IndentyNameBox.showSetModelType" :published="dataObj.published"    :isGener="true" :pageId="formData.pageId"   :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></ArrayType>
        
        
        <AdminModel ref='verifyPwdRef' :showSetModel.sync="adminModelBox.showModel"  :editFormData="adminModelBox.editFormData" :fn="adminModelBox.callbackFn" :loading="adminModelBox.loading"></AdminModel>
   
   
   </div>
</template>
<script>
import common from "@/common/common.js"
import { mapState } from 'vuex'
import NumberType from './component/numberType.vue'
// import BooleanType from './component/boolType.vue'
import TimeType from './component/timeType.vue'
import EnumerationType from './component/enumerationType.vue'
import BitvalueType from './component/bitvalueType.vue'
import EnumerationBool from './component/enumerationBool.vue'
import StructType from './component/structType.vue'
import ArrayType from './component/arrayType.vue'
import AdminModel from './componentOther/showAdminModel.vue';  

export default {
    name:'tabletem',
    props:{
        dataUrl:{
            type:String,
            default:''
        },
        dataParams:{
            type:Object,
            default:()=>{}
        },
        searchObj:{
            type:Object,
            default:()=>{}
        },
        funType:String,
        dataObj:{
            type:Object,
            default:()=>{
                return {
                    loading:true,
                    published:false,
                    pageId:'',
                    result:[]
                }
            }
        },
        isGener:{
            type:Boolean,
            default:false
        },
        hideOperate:{
            type:Boolean,
            default:false
        },
        readOnly:{
            type:Boolean,
            default:false
        },
        
    },
    components: {
        NumberType,
        // BooleanType,
        TimeType,
        EnumerationType,
        BitvalueType,
        EnumerationBool,
        StructType,
        ArrayType,
        AdminModel
    },
    data(){
        return {
            loading:true,
            tableList:{
                tableData:[],
                tableDataALL:[]
            },
            titleName:[],
            dataUrl1:'getBasicKeys',
            IndentyNameBox:{
                showSetModelType:false,
                editFormData:{},
                initdata:{},
                key:{key1:'',key2:''},
                propName:'',
                type:1,
                callbackFn:(e)=>{}
            },
            formData:{
                formatType:'',
                pageId:0
            },
            maxHeight:200,
            page:{//分页排序
                paging:false,
                total:0,//总条数
                pageSize:50,//每页条数
                current:1,//当前页
                key:'id',
                order:'desc'
            },  
             adminModelBox:{
                showModel:false,
                callbackFn:()=>{}, //弹框的回调函数
                editFormData:{},//编辑时传入的现有数据
                loading:false
            },
            sortNumber:-1
        }
    },
    computed:{
         ...mapState(['local','formatTypeObj']),
         localLang(){
            let lang = this.local
            let obj = {'zh-CN':'CN','en-US':'EN'}
            let cur = obj[lang] || ''
            return cur
         },
        titleNameFun(){
            return [
            //    {
            //         title: this.$t('BasicProduct.funcBox.titleName.Order'),
            //         key: 'sortVal',
            //         width:90,
            //         sortable: true,
            //         align:'center',
            //         fixed: 'left',
            //         render: (h, params) => {
            //           //使用抽离出的getRender函数，来执行后续的render行为
            //             return h('Input', this.getRender(h, params, 'sortVal','input')); 
            //         }
            //     },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.Order'),
                    key: 'sortNumber',
                    width:90,
                    sortable: true,
                    align:'center',
                    fixed: 'left',
                    render: (h, params) => {
                      //使用抽离出的getRender函数，来执行后续的render行为
                        if(!params.row.keyName || this.dataObj.published){
                            let stext = params.row.sortNumber || 0
                            return h('div',stext || 0)
                        }else{

                            return h('Input', this.getRenderSort(h, params, 'sortNumber','input')); 
                        }


                        // return h('Input', this.getRenderSort(h, params, 'sortNumber','input')); 

                    }
                },
                
               {
                    title: this.$t('BasicProduct.funcBox.titleName.Identifier'),
                    key: this.dataParams.communicateProtocol==3?'identifier':'keyId',
                    sortable: this.dataParams.communicateProtocol==3?true:false,
                    width: this.dataParams.communicateProtocol==3?220:120,
                    fixed: 'left',
                    render:(h, params)=>{
                        let stext = ''
                        if(this.dataParams.communicateProtocol!=3 && this.funType){

                            let arr = this.funType.split(" ")
                            let str1 = arr[arr.length-1]
    
                            let hexArr = [7,8,9,10,11,12,14]
                            // let keyId =(this.editFormData.formatType*1>=7 && this.editFormData.formatType*1<13)?common.toHex(this.editFormData.keyId*1):this.editFormData.keyId
                            let keyIdFlag = hexArr.indexOf(params.row.formatType*1)>-1?common.toHex(params.row.keyId*1):params.row.keyId
                            stext =str1+" "+keyIdFlag  || ''
                        }

                        if(this.dataParams.communicateProtocol==3){
                            stext = params.row.identifier
                        }



                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.IndentyName'),
                    key: 'keyName',
                    width: 260,
                    fixed: 'left',
                    render:(h, params)=>{
                        let cur = this.localLang
                        let res1 = params.row.keyName
                            try{
                               res1 = JSON.parse(params.row.keyName)
                            } catch{}
                       


                        let stext =  params.row.keyName

                        // console.log('res1',res1)
                        if(Object.prototype.toString.call(res1)=='[object Object]'){
                            stext = cur? res1[cur] :''



                        }else if(Object.prototype.toString.call(res1)=='[object Array]'){
                            stext = res1[0].IndentyName
                            res1.map((item)=>{
                                if(item.LanguageKey==cur){
                                    stext = item.IndentyName
                                }
                            })
                        }
            
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.Bytes'),
                    key: 'hexValueBytes',
                    width: 100,
                },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.RW'),
                    key: 'readWrite',
                    width: 120,
                    render:(h, params)=>{
                        let  obj = {'1':this.$t('selectList.RWlist.RW'),'2':this.$t('selectList.RWlist.R')}
                    
                        let stext = obj[params.row.readWrite] || ''
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
            //    {
            //         title: this.$t('BasicProduct.funcBox.titleName.Musted'),
            //         key: 'required',
            //         width: 100,
            //         render:(h, params)=>{
            //             let obj = {'true':this.$t('selectList.standardTypeList.Yes'),'false':this.$t('selectList.standardTypeList.No')}
            //             let stext = obj[params.row.required] || ''
            //             return h('div',{
            //                 style:{
            //                     display:"none"
            //                 }
            //             },stext || '')
            //         }
            //     },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.UIcontroller'),
                    key: 'taskUiCode',
                    width: 130,
                },
                {
                    title: this.$t('BasicProduct.funcBox.titleName.SenseAction'),
                    key: 'senseAction',
                    width: 130,
                    render:(h, params)=>{
                        let obj = {'true':this.$t('selectList.standardTypeList.Yes'),'false':this.$t('selectList.standardTypeList.No')}
                        let stext = obj[params.row.senseAction] || ''
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.conditionalControl'),
                    key: 'conUiCode',
                    width: 190,
                },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.SenseCondition'),
                    key: 'senseCondition',
                    width: 150,
                    render:(h, params)=>{
                        let obj = {'true':this.$t('selectList.standardTypeList.Yes'),'false':this.$t('selectList.standardTypeList.No')}
                        let stext = obj[params.row.senseCondition] || ''
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
               
                {
                    title: this.$t('BasicProduct.funcBox.titleName.UpdateAsOffline'),
                    key: 'offlineOperation',
                    width: 160,
                    render:(h, params)=>{
                        let obj = {'true':this.$t('selectList.standardTypeList.Yes'),'false':this.$t('selectList.standardTypeList.No')}
                        let stext = obj[params.row.offlineOperation] || ''
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.SenseOperation'),
                    key: 'conditionJudgment',
                    width: 150,
                    render:(h, params)=>{
                        let obj = {'1':">; = ;<",'2':"=",'0':"None"}
                        let stext = obj[params.row.conditionJudgment] || ''
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
               {
                    title: this.$t('BasicProduct.funcBox.titleName.DataType'),
                    key: 'formatType',
                    width: 160,
                    sortable: true,
                    render:(h, params)=>{
                        let stext = '' 
                        // let List = {'1':'Numerical','2':'Enumeration','3':'Boolean','4':'String','5':'Bitvalue','6':'Date time','7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue','12':'Hex Datetime','13':'Structure','14':'Hex SNumerical'}
                        let nameFlag = this.formatTypeObj[params.row.formatType]
                        
                        if(!nameFlag){
                            stext =params.row.formatType
                        }else{
                            stext = nameFlag
                        }
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
                {
                        title: this.$t('productManage.functionModel.titleName.Discription'),
                        key: 'defaultValue',
                        minWidth: 180,
                        render: (h, params) => {

                            //1-数值型，2-枚举型，3-布尔型，4-字符型，5-位值型，6-时间型，7-数值型(16进制)，8-枚举型(16进制)，9-布尔型(16进制)，10-字符型(16进制)，11-位值型(16进制)，12-时间型(16进制),13 strcuture,14 有符号数值型
                            let stext = params.row.formatContent || ''
                            let sarr = null;
                            let resArr = []
                            let resObj = {}
                            let arr = null

                            try {
                                sarr = JSON.parse(params.row.formatContent)
                                arr = sarr[0]
                            } catch (u) {}

                            if(!sarr) return

                            let sarrType = Object.prototype.toString.call(sarr)
                            let arrType = Object.prototype.toString.call(arr)
                   
                            
                            let flagArr = arrType=='[object Array]'?[...arr]:((arrType=='[object Object]' && Array.isArray(sarr))?[...sarr]:[])


                            let formatType = params.row.formatType
                            let lang = this.localLang
                            let timeList = {
                                '1': this.$t('selectList.timeUnit.msceond'),
                                '2': this.$t('selectList.timeUnit.second'),
                                '3': this.$t('selectList.timeUnit.minute'),
                                '4': this.$t('selectList.timeUnit.hour'),
                                '0x01': this.$t('selectList.timeUnit.msceond'),
                                '0x02': this.$t('selectList.timeUnit.second'),
                                '0x03': this.$t('selectList.timeUnit.minute'),
                                '0x04': this.$t('selectList.timeUnit.hour'),
                            }


                    
    
                            if(formatType==1 || formatType==7 || formatType==14 || formatType==15 || formatType==16){//Numerical
                                
                                let obj = {}
                          
                                if(Array.isArray(sarr) && sarr[0]){
                                    obj = {...sarr[0]}

                                    
                                    if(obj.time){ //兼容吕伟平台日期为int类型
                                        stext = this.$t('BasicProduct.funcBox.titleName.time')+' '+ timeList[obj.time]
                                    }else{
                                        obj.Unit = (sarr[0])['Unit-'+lang]
                                        stext = this.$t('BasicProduct.funcBox.titleName.ValueRange')+' '+ obj.Min+'~'+obj.Max
                                    }

                                }else if(sarrType=='[object Object]' && sarr['Max']){
                                    stext = this.$t('BasicProduct.funcBox.titleName.ValueRange')+' '+ sarr.Min+'~'+sarr.Max
                                }
    
    
                            }else if(formatType==2 || formatType==8 || formatType==3 || formatType==9 || formatType==11 || formatType==13){//Enumeration、Boolean、Hex Bitvalue
                                if(flagArr.length){
                                    flagArr.map(item=>{
                                      switch (formatType) {
                                        case 2:
                                        case 8:
                                        case 9:
                                        case 3:
                                            resObj[item.Code]=item['Name-'+lang]
                                            stext = JSON.stringify(resObj)
                                            break;
                                        case 11:
                                            item['Name']=item['Name-'+lang]
                                            resArr.push(item['Name'])
                                            stext = JSON.stringify(resArr)
                                            break;
                                        case 13:
                                            // item['type']=this.formatTypeObj[item.formatType+'']

                                            // let obj = {
                                            //     [item['keyId']]:item['type']
                                            // }
                                            // resArr.push(obj)
                                            // stext ='struct: '+ JSON.stringify(resArr)
                                            stext ='struct'
                                            break;
                                        default:
                                            break;
                                      }
                                    })

                                }else{

                                    if(formatType==13 ){
                                        stext = ''
                                    }
                                }



                            }else if(formatType==6 || formatType==12){
                                stext = this.$t('BasicProduct.funcBox.titleName.time')+' '+timeList[sarr[0].time]
                            }else if(formatType==4 || formatType==10){//string 单位字节
                                stext = this.$t('BasicProduct.funcBox.titleName.stringLang')+' '+stext
                            }else if(formatType==17){//array
                                // let elementType = flagArr[0].elementType
                                // let type = this.formatTypeObj[elementType]
                                // stext = type

                                // if(elementType==13) {

                                //     if(flagArr[0].formatContent){

                                //         let desc = ''
                                //         flagArr[0].formatContent.map(item=>{
                                //             item['type']=this.formatTypeObj[item.formatType+'']
                                //             resArr.push(item['type'])
                                //             desc = JSON.stringify(resArr)
                                //         })
                                //         stext = type+': '+desc
                                //     }else{
                                //         stext = 'struct'
                                //     }
                                // }

                                stext = 'array'


                               
                            }

                            return h('div',{
                                attrs:{
                                    title:stext
                                },
                                style:{
                                    cursor:'pointer'
                                },
                                on:{
                                    click:()=>{this.editType(params.row)}
                                }
                            },stext || '')
					    }
                    },
                {
                    title: this.$t('BasicProduct.funcBox.titleName.Default'),
                    key: 'defaultValue',
                    width: 100,
                    render:(h, params)=>{
                        // let List = {'7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue','12':'Hex Datetime'}
                        let List = {'7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue','12':'Hex Datetime','14':'Hex SNumerical'}
                        let nameFlag = List[params.row.formatType]
                        let stext = (nameFlag && params.row.defaultValue)  ? '0x'+params.row.defaultValue : params.row.defaultValue
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
                {
                    title: this.$t('BasicProduct.funcBox.titleName.Remark'),
                    key: 'remark',
                    minWidth: 220,
                    sortable: true,
                    render:(h, params)=>{
                        let stext = params.row.remark || ''
                        return h('div',{
                            attrs:{
                                title:stext
                            }
                        },stext || '')
                    }
                },
                {
		            title: this.$t('productPage.titleName.Operation'),
                    'title-zh-CN':'操作',
                    'title-en-US':'Operation',
                    // fixed:'right',
		            width:140,
                    key: "Operation",
		            render: (h, params) => {
                        let that = this
                        return h('div',{
                            style:{
                                display:'flex',
                                'justify-content':'center'
                            }
                        },[
                            h('Button',{
		                          props: {
                                      type: "primary",
                                      size: 'small'
                                  },
                                  style:{
                                    'margin-right':'8px'
                                  },
		                          on: {
		                              click: () => { 
                                        //    this.tableList.hasSelectData = params.row
                                           this.$emit('addData',{keyType:this.dataParams.keyType, funType:this.funType,row:params.row,pageId:this.dataObj.pageId})
                                        //    this.addData(2)
                                       }
		                          }
		                      },(this.hideOperate)?that.$t("detail"):that.$t("edit")),
                            h('Poptip', 
                                {
                                     props: {
                                         confirm: true,
                                         transfer:true,
                                         type: 'error',
                                         size: 'large',
                                         title:that.$t("orderManage.deletModel.changeCont")
                                     },
                                     on: {
                                         'on-ok': () => {
                                             if(this.hideOperate) return
                                             let data = {
                                                ...params.row,
                                                published:this.dataObj.published
                                             }
                                             this.$emit('todelData',data)
                                         }
                                     }
                                 }, 
                                 [
                                     h('Button', {
                                         props: {
                                             type: 'error',
                                             size: 'small',
                                             disabled:this.isGener
                                         },
                                         style: {
                                             marginRight: '5px',
                                             display:(this.hideOperate || this.dataParams.communicateProtocol==3)?'none':'inline-block'
                                         },
                                     },that.$t("delete"))
                                ]
                            )
                        ])
		            }
                }
                
            ]
        }
    },
    created(){
       
        this.updateTitleName() 
        // this.dealHeight()
    },
    watch:{
        dataObj:{
           deep:true,
           handler(){
               this.getData()
           }
       },
       '$i18n.locale'() {
            // 语言变化时重新设置titleName
            this.updateTitleName();
        },
        readOnly() {
            // 如果readOnly可能变化，也监听
            this.updateTitleName();
        }
    },
    methods:{
        updateTitleName(){
            this.titleName = this.titleNameFun
            if(this.readOnly){
                 let arr = [this.titleNameFun[2],this.titleNameFun[11],this.titleNameFun[12],this.titleNameFun[13],this.titleNameFun[5]]
                 delete arr[0].fixed
                 this.titleName = arr
                 return
            }
             if(this.dataParams.communicateProtocol==3){//hyeco这种类型的,吕伟平台，不要分类型
             // console.log('this.titleNameFun',this.titleNameFun)
                 let keyType =  {
                     title: this.$t(`BasicProduct.funcBox.sideList.side${this.dataParams.keyType}`),
                     key: 'keyType',
                     width:90,
                     align:'center'
                 }
                 // let arr = [keyType,this.titleNameFun[2],this.titleNameFun[1],this.titleNameFun[13],this.titleNameFun[14],this.titleNameFun[16]]
                 let arr = [...this.titleNameFun]
                 // delete arr[0].fixed
                 arr.splice(3, 1)
                 this.titleName = arr
            }
     
            if(this.dataParams.communicateProtocol==2 || this.dataParams.communicateProtocol==4){ //只有16进制 this.dataParams.communicateProtocol==1的显示字节长度
                 let arr = [...this.titleNameFun]
                 // delete arr[0].fixed
                 arr.splice(3, 1)
                 this.titleName = arr
            }

        },
        dealHeight(){//给表格最大高度动态赋值，要搭配css.ivu-table-fixed{height: 100%;}
            let heightVal = document.querySelector('.ivu-card-body').clientHeight
            if(this.readOnly){
                this.maxHeight = 550
            }else if(this.dataParams.communicateProtocol==3){
                this.maxHeight = heightVal-80
            }else{
                this.maxHeight = '-'
            }
        },
        editType(item){
            return
            if(!this.readOnly || item.formatType==13 || item.formatType==17) return

            let res = item.formatContent

            try {
                res = JSON.parse(item.formatContent)
            } catch (error) {
                
            }
            console.log('resres',item)

            let sarrType = Object.prototype.toString.call(res) =='[object Array]' || Object.prototype.toString.call(res) =='[object Object]'
            this.formData.formatType = item.formatType +''
            this.formData.pageId = (item.keyType==4 || item.keyType==5)?0:this.dataObj.pageId
            
            if(sarrType) this.editTypeDiscription(res)
        },
      

        editTypeDiscription(item){//编辑数据类型详细
            // formatTypeObj: {'1':'Numerical','2':'Enumeration','3':'Boolean','4':'String', '6':'Date time',
            //     '7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue',
            //     '12':'Hex Datetime','13':'Structure','14':'Hex SNumerical','15':'struct(结构体)','16':'array(数组)'}

            console.log('item11',item)
             this.IndentyNameBox.type = 2
             this.hideModel()

             let typeArr1 = ['1','6','7','12','14']

             let IndentyItem = typeArr1.indexOf(this.formData.formatType)>-1?item[0]:item

             console.log('IndentyItem',IndentyItem)
             
             this.IndentyNameBox.editFormData = {IndentyName:IndentyItem,allArr:item}

             if( Object.prototype.toString.call(IndentyItem) =='[object Array]') this.addStatus()

            //  console.log('this.IndentyNameBox.editFormData',this.IndentyNameBox.editFormData)
            //  let typeObj0 = {'2':'Enumeration','8':'Enumeration','11':'Bitvalue','9':'HexBoolean','3':'Boolean'}
            //  let formatType = item.formatType+''
            //  if(typeObj0[formatType]) this.addStatus()
              this.showTypeModel()
              this.IndentyNameBox.callbackFn = (arr,text) => {//回调处理
                //重新载入
                this.hideModel()
            }
        },
        addStatus(){
            // console.log('this.IndentyNameBox.editFormData.IndentyName.item',this.IndentyNameBox.editFormData.IndentyName)
             this.IndentyNameBox.editFormData.IndentyName = this.IndentyNameBox.editFormData.IndentyName.map((items,indexs)=>{ 
                   items.index = indexs+1
                   items.status = 1
                   return items
             }) 
        },
        hideModel(){//所有子组件弹窗关闭
            this.IndentyNameBox.showSetModelType= false
        },
        showTypeModel(){ //对应Type弹框-开
            this.IndentyNameBox.showSetModelType= true
        },
        async getData1(arr=[]){ //获取数据
            // console.log(8888)
            let communicateProtocol=3
            if(arr.length==0){
                let result = []
               
                if(this.dataObj.result ){
                    this.dataObj.result.map((item)=>{
                        if(!this.readOnly && item.keyType == this.dataParams.keyType){
                            result.push(item)
                        }

                    })
                }
                this.tableList.tableData = !this.readOnly?result:this.dataObj.result

                if(communicateProtocol==3) this.tableList.tableData = this.dataObj.result

            }else{
                let result = []
                if(!this.readOnly && this.dataObj.result){
                    this.dataObj.result.map((item)=>{
                        if(item.keyType == this.dataParams.keyType){
                            result.push(item)
                        }
                    })
                }

                if(communicateProtocol==3) result =[...this.dataObj.result]
                this.tableList.tableData = result.map((item)=>{
                      if(item.sortVal==arr[0]){
                          item.sortVal = arr[1]
                      }
                      return item
                })
            }
            this.loading = false

        },
        searchItem(){//搜索数据

            // let listNew = this.tableList.tableDataALL.filter(f => (f['identifier']).indexOf(this.searchObj.identifier) >= 0 || (f['keyId']).indexOf(this.searchObj.identifier) >= 0)
            // this.page.total = listNew.length
            // this.page.current = 1;
            // let start = (this.page.current-1)*this.page.pageSize
            // let end = (this.page.current)*this.page.pageSize
            // this.tableList.tableData = this.tableList.tableDataALL.filter(item=>{
            //     for(let key in this.searchObj){
            //         return item[]
            //     }
            // })
            this.getDataPage()
        },
        async getData(arr=[]){ //获取数据
            // console.log(8888)
            if(arr.length==0){
                let result = []

                if(this.dataObj.result ){
                    this.dataObj.result.map((item)=>{
                        if(!this.readOnly && item.keyType == this.dataParams.keyType){
                            result.push(item)
                        }

                    })
                }
                // this.tableList.tableDataALL = !this.readOnly?result:this.dataObj.result

                // if(this.dataParams.communicateProtocol==3) this.tableList.tableDataALL = this.dataObj.result

                this.tableList.tableDataALL = !this.readOnly?result:common.deepClone([...this.dataObj.result])

                if(this.dataParams.communicateProtocol==3) this.tableList.tableDataALL = common.deepClone([...this.dataObj.result])
                
                
                if(this.tableList.tableDataALL.length>50){//做假分页
                    this.page.paging = true
                    this.page.total = this.tableList.tableDataALL.length
                    this.getDataPage()
                }else{
                    this.page.paging = false
                    this.page.total = 0
                    this.tableList.tableData = common.deepClone([...this.tableList.tableDataALL])
                }

            }else{
                // let result = []
                // if(!this.readOnly && this.dataObj.result){
                //     this.dataObj.result.map((item)=>{
                //         if(item.keyType == this.dataParams.keyType){
                //             result.push(item)
                //         }
                //     })
                // }

                // if(this.dataParams.communicateProtocol==3) result = common.deepClone([...this.dataObj.result])
                // console.log('arr[0]',arr[0])
                // console.log('arr[1]',arr[1])

                // for(let i=0;i<result.length;i++)
                this.tableList.tableDataALL = this.tableList.tableDataALL.map((item)=>{
                    //   if(item.sortVal==1){
                    //       item.sortVal = arr[0]
                    //   }
                      if(item.id== arr[0]){
                          item.sortNumber = arr[1]
                      }
                      return item
                })
                // this.tableList.tableDataALL = common.deepClone([...result])
                // let aaaa = common.deepClone([...result])

                // this.page.order = "normal"
                // if(this.tableList.tableDataALL.length>50){//做假分页
                //     this.getDataPage()
                // }else{
                //     this.tableList.tableData = common.deepClone([...this.tableList.tableDataALL])
                // }
                // console.log('this.tableList.result',result)
                // console.log('this.tableList.tableDataALL0',this.tableList.tableDataALL)
                // console.log('this.tableList.aaaa',aaaa)
                // this.getDataPage()

                if(this.tableList.tableDataALL.length>50){//做假分页
                    this.page.order = "normal"
                    this.getDataPage()
                }else{
                    this.tableList.tableData = common.deepClone([...this.tableList.tableDataALL])
                }
                
            }
            this.loading = false

        },
        getDataPage(){
            let start = (this.page.current-1)*this.page.pageSize
            let end = (this.page.current)*this.page.pageSize
            let key =  this.page.key
            let order = this.page.order

           

            this.tableList.tableDataAll = this.tableList.tableDataALL.sort((a,b)=>{
                if(order=='asc'){
                   return  a[key] === b[key] ? 0 : a[key] > b[key] ? 1 : -1
                }else if(order=='desc'){
                   return  b[key] === a[key] ? 0 : b[key] > a[key] ? 1 : -1
                }
            })

           
            // console.log('this.searchObj.identifier',this.searchObj)
            if(this.searchObj && this.searchObj.identifier){
                let listNew = this.tableList.tableDataALL.filter(item=>{
                    if(item['identifier']){
                        return item['identifier'].indexOf(this.searchObj.identifier) >= 0
                    }else if(item['keyId']){
                        return item['keyId'].indexOf(this.searchObj.identifier) >= 0
                    }
                })
                this.page.total = listNew.length
                this.tableList.tableData = listNew.slice(start,end)
            }else{

                this.tableList.tableData = this.tableList.tableDataALL.slice(start,end)
                this.page.total = this.tableList.tableDataALL.length
            }

            // console.log('this.tableList.tableDataALL1',this.tableList.tableDataALL)
            //     console.log('this.tableList.tableData',this.tableList.tableData)

        },
        getRenderSort(h, params, key,types){//修改组织
            return{
                props: {
                    value: params.row.sortNumber || 0
                },
                class:"input-table",  // 定义一个类来控制单元格的样式
                style:{
                    width:'100%!important',
                },
                on:{
                    'on-blur':async (event) => {
                       //获取编辑行的inde和编辑字段名，对表格数据进行重新赋值，注意：与下拉框取值不一样
                       if(types == 'input'){
                        // console.log(666)
                           let resVal = (event.currentTarget.value).trim()
                            if(resVal==params.row.sortNumber){
                                return
                            }

                            // if(this.dataObj.published){
                            //     params.row.sortNumber = this.tableList.tableData[params.index]['sortNumber']
                            //   return
                            // }

                            // if(!params.row.keyName){
                            //     console.log('params.row.sortNumber',this.tableList.tableData[params.index].sortNumber)
                            //     // params.row.sortNumber = this.tableList.tableData[params.index]['sortNumber']
                            //     params.row.sortNumber = 0
                            //     console.log('params.row.sortNumber', params.row.sortNumber)
                            //     return
                            // }
                            this.setData(params.row,resVal*1,params.index)
                       }
                        
                    }
                }
            }
        },
        async setData(row,sn,index){//排序
            console.log('row',row)
            let url = this.config.urlArray.setBasicKeys

        
            // console.log('res',res)
            let params = {...row,sortNumber:sn}
            // if(this.dataObj.published){
            //      this.showAdminData(url,params)
            //      return
            //  }

            this.axios.post(url, params).then((result) => {
                
                common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                    this.getData([row.id,sn]);//重置表单
                },()=>{
                    row.sortNumber = this.tableList.tableData[index]['sortNumber']
                    // row.sortNumber = this.sortNumber
                })
            })

            // console.log('params.row',row)
        },
        showAdminData(url,params,row) {  //发布后的基础型号修改需要输入管理员密码
            
            this.adminModelBox.showModel = true
            this.adminModelBox.callbackFn = (password) => {//回调处理
                //重新载入
                this.adminModelBox.loading = true;
              
                this.axios.post(url, {...params,password:password}).then((result) => {
                        
                    // common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                    //     this.adminModelBox.loading = false;
                    //     this.$refs.verifyPwdRef.handleCancel()
                    //     setTimeout(() => {//滚动条问题
                    //         this.cancel();
                    //         this.fn()
                    //     }, 0);
                    // },()=>{
                    //     this.adminModelBox.loading = false;
                    // })

                    common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                        this.adminModelBox.loading = false;
                        this.$refs.verifyPwdRef.handleCancel()
                        this.getData([row.id,params.sortNumber]);//重置表单
                    },()=>{
                        row.sortNumber = this.tableList.tableData[index]['sortNumber']
                        this.adminModelBox.loading = false;
                        // row.sortNumber = this.sortNumber
                    })
                }).catch((err) => {
                    this.adminModelBox.loading = false;
                });
            }
        },
        sortCustom (data) {//自定义排序
            this.page.key = data.key
            this.page.order = data.order
            this.page.current = 1
            console.log(' this.page', this.page)
            this.getDataPage()
        },
        changePage (nowpage) {//切换分页
            this.page.current = nowpage
            this.getDataPage()
        },
        changeSize (nowSize) {//切换每页显示条数
            this.page.pageSize = nowSize
            this.page.current = 1
            this.getDataPage()
        },
    }
}
</script>

<style lang="less" scoped>

.basicFuncTable{

    /deep/ .input-table{
        .ivu-input{
            border: 1px solid #fff;
            text-align: center;
        }
    }

    // .hyecoTable{

    //     /deep/ .ivu-table-fixed{
    //         height: 100%;
    //     }
    // }


    .hyecoTable{

        /deep/ .ivu-table-body{
            max-height: calc(100vh - 280px) !important;
        }
    }

    .hyecoTablePage{

        /deep/ .ivu-table-body{
            max-height: calc(100vh - 435px) !important;
        }

    }



    /deep/ .ivu-table-fixed,.ivu-table-fixed-right{
      height: 100%;
    }
    /deep/ .ivu-table-fixed-body{
      height: calc(~'100% - 48px') !important;
    }




    // /deep/ .ivu-table-fixed-body{
    //     height: calc(100% - 6px) !important;
    //     max-height: 500px;
    //     overflow-y: auto;
    // }
}
</style>